/**
 * Rechtstreeks bestellen bij Albert Heijn.
 *
 * AH accepteert een deeplink die producten in één keer in het mandje legt:
 *
 *     https://www.ah.nl/mijnlijst/add-multiple?p=<productId>:<aantal>&p=…
 *
 * Meer zit er niet achter. Receptensites die "direct bestellen bij AH" doen,
 * gebruiken dezelfde link; wat zij extra hebben is een dienst die de
 * ingrediënten aan concrete producten koppelt (en er een affiliate-link
 * omheen zet). Dat koppelen doen wij zelf, via `ahId` in de productcatalogus.
 */
export const AH_MANDJE_URL = 'https://www.ah.nl/mijnlijst/add-multiple';
/**
 * De deeplink voor deze regels, of `null` als er niets te bestellen valt.
 *
 * Dezelfde producten worden bij elkaar opgeteld en het aantal wordt naar boven
 * afgerond: een halve pot bestaat in het mandje niet.
 */
export function bouwAhBestelUrl(regels) {
    const perProduct = new Map();
    for (const regel of regels) {
        if (!Number.isFinite(regel.ahId) || regel.ahId <= 0)
            continue;
        const aantal = Math.max(1, Math.ceil(regel.aantal || 1));
        perProduct.set(regel.ahId, (perProduct.get(regel.ahId) ?? 0) + aantal);
    }
    if (perProduct.size === 0)
        return null;
    const query = [...perProduct].map(([id, aantal]) => `p=${id}:${aantal}`).join('&');
    return `${AH_MANDJE_URL}?${query}`;
}
/** Zoeken op ah.nl, voor producten waar we geen product-ID van hebben. */
export function ahZoekUrl(naam) {
    return `https://www.ah.nl/zoeken?query=${encodeURIComponent(naam)}`;
}
//# sourceMappingURL=ah.js.map